import { all } from 'redux-saga/effects';

import * as modules from 'modules/index';

import app from './app/sagas';
import materials from './materials/sagas';
import orders from './orders/sagas';
import quotes from './quotes/sagas';
import session from './session/sagas';
import supplier from './supplier/sagas';

export default function* rootSaga() {
  yield all([
    modules.saga(),
    app(),
    session(),
    orders(),
    quotes(),
    supplier(),
    materials(),
  ]);
}
